module.exports = __webpack_public_path__ + "static/media/branding-logo.cb272fc5.png";